.chipContainer {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #444;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  padding: 4px 8px 4px 12px;
  border-radius: 16px;
  white-space: nowrap;
  transition: all 0.2s ease;
  gap: 6px;

  animation: chip-in 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

  &:hover {
    background-color: #ececec;
    border-color: #ccc;
  }
}

.closeButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #bbb;
  color: white;
  border: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  line-height: 2;
  transition: background 0.2s ease, transform 0.2s ease;
  padding: 0;
  margin: 0;

  svg {
    scale: 0.6;
    pointer-events: none;
  }

  &:hover {
    background: #888;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.9);
  }
}

@keyframes chip-in {
  0% {
    opacity: 0;
    transform: translateY(8px) scale(0.95);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}